// Auto generated by typegen from Prisma Schema

export enum ClaimState {
	NEW = "NEW",
	OPEN = "OPEN",
	DISMISSED = "DISMISSED",
	DENIED = "DENIED",
	APPROVED = "APPROVED",
	RESOLVED = "RESOLVED",
	ARCHIVED = "ARCHIVED",
	COMMUNICATING = "COMMUNICATING",
	WAITING_FOR_CUSTOMER = "WAITING_FOR_CUSTOMER",
	WAITING_FOR_BRAND = "WAITING_FOR_BRAND",
	WAITING_FOR_OP = "WAITING_FOR_OP",
	RESOLVED_BY_BRAND = "RESOLVED_BY_BRAND",
	TEMPORARILY_DISMISSED = "TEMPORARILY_DISMISSED",
	CLOSED = "CLOSED",
	DRAFT = "DRAFT",
}

export enum ClaimFiledFrom {
	EXTERNAL = "EXTERNAL",
	INTERNAL = "INTERNAL",
}

export enum ClaimType {
	STOLEN = "STOLEN",
	DAMAGED = "DAMAGED",
	DEFECTIVE_ITEM = "DEFECTIVE_ITEM",
	ORDER_DELIVERED_NOT_RECEIVED = "ORDER_DELIVERED_NOT_RECEIVED",
	WRONG_ITEM = "WRONG_ITEM",
	MISSING_ITEM = "MISSING_ITEM",
	RETURNED_TO_SENDER = "RETURNED_TO_SENDER",
	TRACKING_NOT_MOVING = "TRACKING_NOT_MOVING",
	MULTIPLE = "MULTIPLE",
	WRONG_ADDRESS = "WRONG_ADDRESS",
}

export enum ClaimCategory {
	SHIPPING = "SHIPPING",
	WARRANTY = "WARRANTY",
}

export enum SalesChannel {
	ONLINE = "ONLINE",
	IN_STORE = "IN_STORE",
}

export enum ResolutionType {
	RESHIP = "RESHIP",
	DRAFT_ORDER = "DRAFT_ORDER",
	REPLACEMENT = "REPLACEMENT",
	REFUND = "REFUND",
	FLAT_RATE = "FLAT_RATE",
	FLAT_RATE_STORE_CREDIT = "FLAT_RATE_STORE_CREDIT",
	CUSTOM = "CUSTOM",
	EXPIRED30 = "EXPIRED30",
	EXCHANGE = "EXCHANGE",
	CREDIT = "CREDIT",
	STORE_CREDIT = "STORE_CREDIT",
	RETURN = "RETURN",
	OTHER = "OTHER",
	NO_RESPONSE = "NO_RESPONSE",
	PACKAGE_ARRIVED = "PACKAGE_ARRIVED",
	CUSTOMER_RESPONDED = "CUSTOMER_RESPONDED",
	FOLLOW_UP = "FOLLOW_UP",
	INSUFFICIENT_SHIPPER = "INSUFFICIENT_SHIPPER",
	RETURN_TO_SENDER = "RETURN_TO_SENDER",
	NOT_COVERED = "NOT_COVERED",
	ADRESS_TYPO = "ADRESS_TYPO",
	PHOTO_VERIFIED = "PHOTO_VERIFIED",
	THRESHOLD_REACHED = "THRESHOLD_REACHED",
	ADDRESS_TYPO = "ADDRESS_TYPO",
	ALREADY_REFUNDED = "ALREADY_REFUNDED",
	ALREADY_REPLACED = "ALREADY_REPLACED",
	POTENTIAL_FRAUD = "POTENTIAL_FRAUD",
}

export enum ResolutionSubject {
	ITEM = "ITEM",
	SHIPPING = "SHIPPING",
	TAXES = "TAXES",
	ACTION = "ACTION",
}

export enum ClaimSessionStatus {
	PROCESS = "PROCESS",
	ISSUES = "ISSUES",
	ISSUES_ITEMS = "ISSUES_ITEMS",
	ISSUES_SHIPMENT = "ISSUES_SHIPMENT",
	ISSUES_SHIPMENT_DETAILS = "ISSUES_SHIPMENT_DETAILS",
	MULTIPLE_SHIPMENTS = "MULTIPLE_SHIPMENTS",
	RESOLUTION = "RESOLUTION",
	RESOLUTION_REVIEW = "RESOLUTION_REVIEW",
}

export enum StoreCreditType {
	GIFT_CARD = "GIFT_CARD",
	DISCOUNT_CODE = "DISCOUNT_CODE",
}

export enum ActivityType {
	MESSAGE = "MESSAGE",
	EVENT = "EVENT",
}

export enum ActivitySourceType {
	SYSTEM = "SYSTEM",
	USER = "USER",
	OTHER = "OTHER",
}

export enum HybridOperator {
	AND = "AND",
	OR = "OR",
}

export enum Origination {
	ORDER = "ORDER",
	CLAIM = "CLAIM",
}

export enum PolicyType {
	SHIPPING = "SHIPPING",
	MANUFACTURER_WARRANTY = "MANUFACTURER_WARRANTY",
	EXTENDED_WARRANTY = "EXTENDED_WARRANTY",
}

export enum PricingModel {
	COST_PER_ORDER = "COST_PER_ORDER",
	COST_PER_ORDER_ITEM = "COST_PER_ORDER_ITEM",
	COST_PER_RESOLUTION = "COST_PER_RESOLUTION",
}

export enum SenderType {
	customer = "customer",
	brand = "brand",
	admin = "admin",
	automatic = "automatic",
	system = "system",
}

export enum CalcMethod {
	percentage = "percentage",
	fixed = "fixed",
}

export enum DocumentType {
	SIGNATURE = "SIGNATURE",
	ACKNOWLEDGEMENT = "ACKNOWLEDGEMENT",
	RECEIPT = "RECEIPT",
}

export enum StoreCreditRedeemedStatus {
	YES = "YES",
	NO = "NO",
	PARTIALLY = "PARTIALLY",
}

export interface Policy {
	id: string;
	orderId: string;
	storeId: string;
	insuredAmount: number;
	premiumPaid: number;
	premiumDiscountedAmount: number;
	premiumCurrency: string;
	fundedBy: string;
	customerAmount: number;
	brandAmount: number;
	hybridOperator: HybridOperator | null;
	policyType: PolicyType;
	pricingModel: PricingModel | null;
	createdAt: string | null;
	updatedAt: string | null;
	removedAt: string | null;
	deletedAt: string | null;
	warranty: Warranty[];
	claim: Claim[];
}

export interface Warranty {
	id: string;
	policyId: string;
	orderItemId: string;
	warrantyId: string;
	validUntil: string | null;
	validity: string;
	policy: Policy;
}

export interface Activity {
	id: string;
	claimId: string;
	source: string;
	sourceType: ActivitySourceType;
	activityType: ActivityType;
	description: string;
	imageUrl: string | null;
	createdAt: string;
	claim: Claim;
}

export interface Claim {
	id: string;
	storeId: string;
	orderId: string;
	sourceOrderId: string;
	sourceOrderNumber: string;
	customerId: string | null;
	authorName: string;
	authorEmail: string;
	claimDescription: string;
	claimState: ClaimState;
	isOta: boolean;
	otaDescription: string | null;
	claimSource: string | null;
	claimType: ClaimType | null;
	claimCategory: ClaimCategory;
	salesChannel: SalesChannel;
	claimFiledFrom: ClaimFiledFrom;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claimItems: ClaimItem[];
	claimMessages: ClaimMessage[];
	claimResolutions: ClaimResolution[];
	claimCredits: ClaimCredit[];
	review: Review | null;
	claimStoreCredits: ClaimStoreCredit | null;
	activities: Activity[];
	policy: Policy | null;
	policyId: string | null;
	claimDocuments: ClaimDocument[];
	warrantyMetadata: WarrantyMetadata | null;
}

export interface WarrantyMetadata {
	id: string;
	claimId: string;
	warrantyPeriod: string;
	receiptRequired: boolean;
	dateOfPurchase: string;
	warrantyFee: number;
	productValue: number;
	isValidated: boolean;
	productDescription: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimItemImage {
	id: string;
	url: string;
	claimItemId: string;
	filename: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: ClaimItem;
}

export interface ClaimItem {
	id: string;
	name: string;
	claimId: string;
	orderId: string;
	sourceItemId: string | null;
	sourceOrderId: string;
	sourceProductId: string | null;
	sourceVariantId: string | null;
	sku: string | null;
	resolutionRequested: ResolutionType | null;
	resolutionFinal: ResolutionType | null;
	isAdditionalItem: boolean;
	imageUrl: string | null;
	quantity: number;
	resolutionQuantity: number | null;
	resolutionPercentage: number | null;
	resolutionFlatAmount: number | null;
	resolutionId: string | null;
	claimType: ClaimType;
	claimSubtypeId: string | null;
	details: string;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	resolution: ClaimResolution | null;
	images: ClaimItemImage[];
	claimSubtype: ClaimSubtype | null;
}

export interface ClaimSession {
	id: string;
	orderId: string;
	email: string;
	status: ClaimSessionStatus;
	metadata: object | null;
	createdAt: string;
	updatedAt: string;
}

export interface ClaimMessage {
	id: string;
	messageContent: string;
	senderName: string;
	senderType: SenderType;
	senderId: string | null;
	readAt: string | null;
	claimId: string;
	htmlBody: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	medias: ClaimMessageMedia[];
}

export interface ClaimResolution {
	id: string;
	claimId: string;
	userId: string | null;
	resolutionType: ResolutionType;
	resolutionDetails: string;
	paidValue: number;
	paidCurrency: string;
	paidOriginalValue: number;
	includeShipping: boolean;
	shippingAmount: number;
	creditStore: boolean;
	overrideShipping: boolean;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	credits: ClaimCredit[];
	claimItems: ClaimItem[];
}

export interface ClaimCredit {
	id: string;
	claimId: string;
	claimResolutionId: string;
	creditAmount: number;
	creditTarget: string;
	creditCurrency: string;
	creditReason: string;
	creditIssuedBy: string;
	paymentGateway: string;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	resolution: ClaimResolution;
}

export interface ClaimStoreCredit {
	id: string;
	sourceId: string | null;
	claimId: string | null;
	storeId: string | null;
	origination: Origination;
	orderId: string | null;
	type: StoreCreditType;
	code: string;
	emailStatus: string;
	emailTime: string | null;
	creditCurrency: string;
	exchangeRate: number;
	creditValue: number;
	bonusValue: number | null;
	totalValue: number;
	bonus: number | null;
	bonusType: CalcMethod | null;
	remainingValue: number | null;
	redeemed: StoreCreditRedeemedStatus | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim | null;
	claimStoreCreditUsage: ClaimStoreCreditUsage[];
}

export interface ClaimMessageMedia {
	id: string;
	claimMessageId: string;
	fileKey: string;
	caption: string;
	filename: string;
	downloadLink: string | null;
	url: string;
	fileType: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claimMessage: ClaimMessage;
}

export interface ClaimDocument {
	id: string;
	url: string;
	claimId: string;
	documentType: DocumentType;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimStoreCreditUsage {
	id: string;
	claimStoreCreditId: string;
	orderId: string;
	usageAmount: number;
	usedAt: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claimStoreCredit: ClaimStoreCredit;
	warrantyMetadataId: string | null;
}

export interface Review {
	id: string;
	claimId: string;
	rating: number;
	comments: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimSubtype {
	id: string;
	name: string;
	category: ClaimCategory;
	parentType: ClaimType;
	storeId: string;
	createdAt: string;
	updatedAt: string;
	voidedAt: string | null;
	claimItems: ClaimItem[];
}

